// extracted by mini-css-extract-plugin
export var configurationSection = "_rd-0";